import React from "react";
import missionStatement from "../../static/img/mission-statement.webp";

export interface StaticImageLibraryProps {
	imageName: string;
	className: string;
}

export const StaticImageLibrary: React.FC<StaticImageLibraryProps> = ({
	imageName,
	className,
}) => {
	const getImage = () => {
		switch (imageName) {
			case "CaredForSummer":
				return missionStatement;
		}
	};

	return (
		<img
			src={getImage()}
			className={className}
			alt="Adult German Shepherd, outside under leaves"
			aria-hidden="true"
		/>
	);
};

export default StaticImageLibrary;
